export default {
  sections: {
    order_summary: 'Tilauksen summa',
  },
  labels: {
    add_items: 'Lisää tuotteita aloittaaksesi',
    item_count_one: '{{count}} tuote',
    item_count_other: '{{count}} tuotetta',
  },
  buttons: {
    return: 'Takaisin tilauksen tarkistukseen',
  },
};
